<script setup lang="ts">
</script>

<template>
  <div
    class="card-container"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.card-container {
  @apply border rounded-lg bg-card-background/5 border-card-background/20;
}
</style>